module.exports = __webpack_public_path__ + "img/ESG_02_2.9299bee4.jpg";